import axiosInstance from "../axiosInstance";

export const settingsApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/settings${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/settings${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getApplicationTypes = async () =>
  settingsApi.get("/getApplicationTypes");

export const postApplicationTypes = async (params) =>
  settingsApi.post("/postApplicationTypes", params);

export const getSeasons = async () => settingsApi.get("/getSeasons");

export const postSeasons = async (params) =>
  settingsApi.post("/postSeasons", params);



export const getApplicationTypeSeasons = async () =>
  settingsApi.get("/getApplicationTypeSeasons");

export const postApplicationTypeSeasons = async (params) =>
  settingsApi.post("/postApplicationTypeSeasons", params);
